import React, { useState, useEffect, useMemo } from 'react'
import close from '../Asset/close.svg'
import { Link } from 'react-router-dom'
import { Modal, Form } from 'react-bootstrap'
import Alert from './Alert';
import Table from './tables/addAdminTable';
import { getUserInfo } from './functions/userInfo'
import SessionFun from './functions/sessionFun'
import { environment } from './functions/environment';

function Render() {
  let userObj = getUserInfo();
  let [sessOut, setSessOut] = useState(false);
  let [userByAccount, setuserByAccount] = useState([]);
  const [show, setShow] = useState(false);
  const handleClose = () => {
    setShow(false);
    setErrorMsg({})
    setInfo({
      accountID: "",
      roleID: null,
      firstName: "",
      lastName: "",
      mobileNo: "",
      emailID: "",
      userID: null,
      optype: "",
      isActive:true,
    })
  }
  const handleShow = () => {
    setShow(true);

  }

  let [alert, setAlert] = useState({
    msg: "",
    status: false
  });
  useEffect(() => {
    getUserByAccID();
  }, [])
  let [info, setInfo] = useState({
    accountID: "",
    siteID: null,
    roleID: null,
    firstName: "",
    lastName: "",
    mobileNo: "",
    emailID: "",
    groupID: "",
    userType: "admin",
    userID: null,
    isActive: true,
    optype: ""
  });
  function getAccountUserFormData(e) {
    setInfo({ ...info, [e.target.name]: e.target.value });
  }
  function saveAccountUserForm(e) {
    fetch(environment.baseUrl + "usersRegistration", {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      },
      body: JSON.stringify({
        accountID: userObj.accountID,
        roleID: 7,
        firstName: info.firstName,
        lastName: info.lastName,
        mobileNo: info.mobileNo,
        emailID: info.emailID,
        groupID: info.groupID,
        userType: "admin",
        isActive: info.isActive == "true"? true: false,
      })
    }).then((result) => {
      result.json().then((res) => {
        if (res.code == 200) {
          getUserByAccID();
          handleClose();
          setAlert({
            msg: "Admin user added successfully",
            status: true
          });

        }
        else if (res.code == 400) {
          setAlert({
            msg: res.msg,
            status: true
          });
        }
        else if (res.code == 401) {
          setSessOut(true);
        }
      })
    })
  }
  function updateAccountUser() {
    fetch(environment.baseUrl + "updateUser", {
      method: "PUT",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      },
      body: JSON.stringify({
        userID: info.userID,
        phoneNumber: info.mobileNo,
        firstName: info.firstName,
        lastName: info.lastName,
        email: info.emailID,
        isActive: info.isActive
      })
    }).then((apiRes) => {
      apiRes.json().then((resp) => {
        getUserByAccID();
        handleClose();
        setAlert({
          msg: resp.msg,
          status: true
        });

        if (resp.code == 200) {
        }
        else if (resp.code == 401) {
          setSessOut(true);
        }
      })
    })

  }
  function getUserByAccID() {
    fetch(environment.baseUrl + "getUserByAccID?", {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      },
      body: JSON.stringify({
        "accountID": userObj.accountID,
        "userType": "admin"
      })
    })
      .then((apiRes) => {
        apiRes.json().then((resp) => {
          if (resp.code == 200) {
            setuserByAccount(resp.data.result);
          }
          else if (resp.code == 401) {
            setSessOut(true);
          }
        })
      })
  }
  function editAccountUser(currentObj) {
    setInfo({
      ...info,

      firstName: currentObj.firstName,
      lastName: currentObj.lastName,
      mobileNo: currentObj.phoneNumber,
      emailID: currentObj.emailID,
      userID: currentObj.userID,
      optype: "edit",
      isActive: currentObj.isActive
    })
    setShow(true);
  }
  let [errorMsg, setErrorMsg] = useState({});
  function assetUserValidate() {
    const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const phoneRegex = /^[0]?[6789]\d{9}$/;
    let errror = {};

    if (info.firstName == "") {
      errror.firstName = "This field is required";//Select Acoount"
    }
    if (info.firstName.length > 25) {
      errror.firstName = "Exceeded 25 characters limit";//Select Acoount"
    }

    if (info.lastName == "") {
      errror.lastName = "This field is required";//Select Acoount"
    }
    if (info.lastName.length > 25) {
      errror.lastName = "Exceeded 25 characters limit";//Select Acoount"
    }

    if (info.mobileNo == " ") {
      errror.mobileNo = "This field is required";//Select Acoount"
    }
    else if (info.mobileNo.match(phoneRegex)) {
    }
    else {
      errror.mobileNo = "Enter valid mobile number";
    }
    if (info.mobileNo != "" && info.mobileNo.length > 10 || info.mobileNo != "" && info.mobileNo.length < 10) {
      errror.mobileNo = "Enter valid mobile number";//Select Acoount"
    }
    if (isNaN(info.mobileNo)) {
      errror.mobileNo = "Mobile number must be in digit";
    }

    if (info.emailID == "") {
      errror.emailID = "This field is required";//Select Acoount"
    }

    else if (info.emailID.match(emailRegex)) {
    }
    else {
      errror.emailID = "Enter valid email format";
    }


    setErrorMsg(errror);
    if (Object.keys(errror).length == 0) {
      if (info.optype == "edit") {
        updateAccountUser();
      }
      else {
        saveAccountUserForm();
      }
    }

  }
  const columns = useMemo(
    () => [
      {
        Header: 'First Name ',
        accessor: 'firstName',
      },
      {
        Header: 'Last Name',
        accessor: 'lastName',
      },
      {
        Header: 'Phone No. ',
        accessor: 'phoneNumber',
      },
      {
        Header: 'Email ID',
        accessor: 'emailID',
      },
      {
        Header: 'Status',
        accessor: 'isActive',
      },
      {
        Header: 'Action',
        accessor: 'action',
      },
    ],
    []
  )

  return (
    <div className='main-container'>
      <SessionFun show={sessOut}></SessionFun>
      <Alert obj={alert} />
      <h4 className='main-heading'>Add Admin User</h4>
      <p className='short-link'><Link to='/'>Home&nbsp;<i className='fa fa-angle-right'></i></Link>&nbsp; Add Admin User</p>
      <div className="card-box-block mt-3" style={{ width: "100%" }}>

        <Table columns={columns} data={userByAccount} addFun={handleShow} editFun={editAccountUser} />

      </div>

      <Modal show={show} onHide={handleClose} centered backdrop="static" size="lg">
        <Modal.Header>
          <Modal.Title>{info.optype == "edit" ? "Edit Admin User" : "Add Admin User"} </Modal.Title>
          <button onClick={handleClose} type="button" className="close">
            <img src={close} alt="" />
          </button>
        </Modal.Header>
        <Modal.Body className=' logout-box'>
          {/* Row 1 */}
          <div className="row">

            <div className="col-sm-4 left-col">
              <Form.Group className="mb-3" >
                <Form.Label>First Name<span style={{ color: "red" }}>*</span></Form.Label>
                <Form.Control name="firstName" type="text" className="textbox-back" placeholder="First Name" value={info.firstName} onChange={getAccountUserFormData} readOnly={info.optype == "edit" ? true : false} />
                <small className='red'>{errorMsg.firstName}</small>
              </Form.Group>
            </div>
            <div className="col-sm-4">
              <Form.Group className="mb-3" >
                <Form.Label>Last Name<span style={{ color: "red" }}>*</span></Form.Label>
                <Form.Control name="lastName" type="text" className="textbox-back" placeholder="Last Name" value={info.lastName} onChange={getAccountUserFormData} readOnly={info.optype == "edit" ? true : false} />
                <small className='red'>{errorMsg.lastName}</small>
              </Form.Group>
            </div>
            <div className="col-sm-4">
              <Form.Group className="mb-3" >
                <Form.Label>Email ID<span style={{ color: "red" }}>*</span></Form.Label>
                <Form.Control name="emailID" type="text" className="textbox-back" placeholder="Email Id" value={info.emailID} onChange={getAccountUserFormData} readOnly={info.optype == "edit" ? true : false} />
                <small className='red'>{errorMsg.emailID}</small>
              </Form.Group>
            </div>
          </div>
          {/* Row 2 */}
          <div className="row">
            <div className="col-sm-4 left-col">
              <Form.Group className="" >
                <Form.Label>Phone Number<span style={{ color: "red" }}>*</span></Form.Label>
                <Form.Control name="mobileNo" type="text" className="textbox-back" maxLength={10} placeholder="Phone Number" value={info.mobileNo} onChange={getAccountUserFormData} />
                <small className='red'>{errorMsg.mobileNo}</small>
              </Form.Group>
            </div>

            <div className="col-sm-4">
              <Form.Group className="mb-3" >
                <Form.Label>Status<span style={{ color: "red" }}>*</span></Form.Label>
                <Form.Select name="isActive" as="select" className="textbox-back" aria-label="Default select example" value={info.isActive} onChange={getAccountUserFormData}>
                  <option value="true">Active</option>
                  <option value="false">Inactive</option>
                </Form.Select>
              </Form.Group>
            </div>

          </div>

          {/* Row 3 */}
          <div className="row">
            <div className="col-sm-4 left-col">

            </div>
            <div className="col-sm-4">

            </div>
            <div className="col-sm-4">
              <button className="add-btn btn-light lo-btn confirm-btn float-end" onClick={assetUserValidate}>
                {info.optype == "edit" ? "Update" : "Save"}

              </button>
            </div>
          </div>
          {/* </Form> */}
        </Modal.Body>
      </Modal>

    </div>

  )
}

export default Render
